import { errorCodes, getUserFriendlyErrorMessage } from '../../../utils/errormessages'
import { serviceTypeTableDefaultErrorsConfig } from '../constants'
import type { NewServiceVisitType, SetToastError, VisitTypeErrorState } from '../types'
import { checkCostErrors } from './checkCostErrors'
import { checkFromsErrors } from './checkFormsErrors'
import { checkTextErrors } from './checkTextErrors'

export const checkErrors = (serviceType: NewServiceVisitType, setToastError: SetToastError): VisitTypeErrorState => {
  const { VisitTypeId } = serviceType

  const errorsObj = structuredClone(serviceTypeTableDefaultErrorsConfig)
  errorsObj.id = VisitTypeId

  const { nameError, descriptionError } = checkTextErrors(serviceType)
  const { costError, cancelationFeeError } = checkCostErrors(serviceType)
  const { consentFormError, intakeFormError } = checkFromsErrors(serviceType)

  const isShouldShowToastError =
    nameError || descriptionError || costError || cancelationFeeError || consentFormError || intakeFormError

  if (isShouldShowToastError) {
    setToastError(getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS))
  }

  return {
    ...errorsObj,
    errors: {
      ...errorsObj.errors,
      visitNameError: !!nameError,
      visitNameLocalError: nameError,
      visitDescriptionError: !!descriptionError,
      visitDescriptionLocalError: descriptionError,
      coastUSDError: !!costError,
      coastUSDLocalError: costError,
      // Preserve the original validator's typo'd key (single "l") verbatim — the downstream
      // error-count checks iterate it. The canonical key keeps its default '' value, matching legacy.
      cancelationFeeError: !!cancelationFeeError,
      cancellationFeeLocalError: cancelationFeeError,
      consentFormError: !!consentFormError,
      consentFormLocalError: consentFormError,
      intakeFormError: !!intakeFormError,
      intakeFormLocalError: intakeFormError,
    },
  }
}
